import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, Subject } from "rxjs";

import { AuthServices } from "../auth.service";
import { Injectable } from "@angular/core";
import { endpoints } from "src/app/_config/url-endpoint";

const rentalPartnerUrl = endpoints.rental.partnerUrl;

@Injectable({
  providedIn: "root",
})
export class RentalPartnerService {
  private savePartnerVal = new Subject<any>();

  constructor(private http: HttpClient, private authService: AuthServices) {}

  getPartners(queryString): Observable<any> {
    return this.http.get(`${rentalPartnerUrl}?${queryString}`, this.authService.getAccessHeaders());
  }

  createPartner(body): Observable<any> {
    return this.http.post(`${rentalPartnerUrl}`, body, this.authService.getAccessHeaders());
  }

  getPartnerDetails(partnerId): Observable<any> {
    return this.http.get(`${endpoints.rental.partnerDetailUrl}/${partnerId}`, this.authService.getAccessHeaders());
  }

  editPartner(partnerId, body): Observable<any> {
    return this.http.patch(`${rentalPartnerUrl}/${partnerId}`, body, this.authService.getAccessHeaders());
  }

  getPartnerCount(tenantId): Observable<any> {
    return this.http.get(`${rentalPartnerUrl}/status-count?tenantId=${tenantId}`, this.authService.getAccessHeaders());
  }

  changePartnerStatus(partnerId, body): Observable<any> {
    return this.http.post(
      `${endpoints.rental.changeRentalPartnerStatus}${partnerId}`,
      body,
      this.authService.getAccessHeaders(),
    );
  }

  getPartner(): Observable<any> {
    return this.http.get(endpoints.partnerPage.getPartner, this.authService.getAccessHeaders());
  }

  downloadFile(queryString): Observable<any> {
    return this.http.get(`${rentalPartnerUrl}/export?${queryString}`, {
      headers: (this.authService.getAccessHeaders() as { headers: HttpHeaders }).headers,
      responseType: "blob",
    });
  }

  updateIdentityDocuments(body: any): Observable<any> {
    return this.http.post(endpoints.rental.partnerOnboardingUrl, body, this.authService.getAccessHeaders());
  }

  rejectionReason(body: { partnerId: string; rejectionReason: string }): Observable<any> {
    return this.http.post(`${endpoints.rental.partnerOnboardingUrl}/rejection-reason`, body, this.authService.getAccessHeaders());
  }

  uploadDocuments(formData: FormData): Observable<any> {
    return this.http.post(`${rentalPartnerUrl}/documents/upload`, formData, this.authService.getAccessHeaders());
  }

  updateSpocPhone(partnerId: string, body: { countryCode: string; mobileNumber: string }): Observable<any> {
    const url = `${endpoints.rental.updateSpocPhoneUrl}/${partnerId}/phone`;
    return this.http.put(url, body, this.authService.getAccessHeaders());
  }

  updateSpocEmail(partnerId: string, body: { email: string }): Observable<any> {
    const url = `${endpoints.rental.updateSpocEmailUrl}/${partnerId}/email`;
    return this.http.put(url, body, this.authService.getAccessHeaders());
  }

  public setRefreshPartner(data: any) {
    this.savePartnerVal.next({ result: data });
  }

  public getRefreshPartner(): Observable<any> {
    return this.savePartnerVal.asObservable();
  }
}
